/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".pdf-frame[_ngcontent-%COMP%]{border-bottom-right-radius:5px;border-bottom-left-radius:5px}"];
export { styles as styles };
